import React from "react";

const ScriptwritingMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://sunrisingcinevisionacademy.com/public/assets/images/script-writing1.jpg" alt="Script Writing" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Screenwriting with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy, one of the leading film schools, offers a structured <strong>script writing course</strong> for aspiring writers. Whether you're looking for <strong>scriptwriting classes</strong>, a <strong>screenwriting course</strong>, or in-depth training in <strong>scriptwriting</strong>, this program covers everything from fundamental techniques to advanced industry practices. Gain hands-on experience with professional scriptwriting software and mentorship from industry experts to build a successful career in <strong>screenplay writing</strong>.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Core principles of scriptwriting and storytelling</li>
              <li>Mastering industry-standard software like Final Draft and Celtx</li>
              <li>Understanding script structure, formatting, and dialogue</li>
              <li>Developing compelling characters and strong narratives</li>
              <li>Rewriting, editing, and preparing scripts for production</li>
            </ul>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li><strong>Level:</strong> Beginner to Advanced</li>
              <li><strong>Duration:</strong> 12 Weeks</li>
              <li><strong>Certification:</strong> Certificate in Script Writing</li>
              <li><strong>Career Paths:</strong> Screenwriter, Script Editor, Story Consultant, Playwright, TV Writer</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 1: Introduction to Script Writing</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>What is scriptwriting?</li>
              <li>Types of scripts (film, TV, theater)</li>
              <li>Basics of script format, structure, and dialogue</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 2: Storytelling Fundamentals</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Developing unique ideas and concepts</li>
              <li>Creating compelling characters</li>
              <li>Understanding plot, theme, and genre</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 3: Script Structure and Formatting</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>The three-act structure in screenwriting</li>
              <li>Writing effective scenes and transitions</li>
              <li>Formatting scripts to industry standards</li>
              <li>Using scriptwriting software for professional formatting</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 4: Character Development and Dialogue</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Creating complex, believable characters</li>
              <li>Writing natural and impactful dialogue</li>
              <li>Understanding character arcs and subtext</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 5: Plot and Pacing</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Building tension, conflict, and resolution</li>
              <li>Creating suspense and surprise elements</li>
              <li>Understanding pacing and timing in storytelling</li>
              <li>Incorporating plot twists and turns</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 6: Rewriting and Editing</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>The rewriting process: from draft to final script</li>
              <li>Editing for structure, character, and dialogue</li>
              <li>Using feedback and constructive criticism</li>
              <li>Preparing a polished script for production</li>
            </ul>
          </div>
        </div>

        {/* Practical Experience, Faculty, Software, Certification, Partnerships */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Practical Experience</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Weekly scriptwriting assignments</li>
              <li>Script analysis feedback sessions</li>
              <li>Final script project (10-20 pages)</li>
              <li>Collaborative writing exercises</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Expert Faculty & Guest Lectures</h3>
            <h4 className="font-semibold mb-2">Faculty:</h4>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Experienced screenwriters, script editors, and directors</li>
              <li>Industry professionals with extensive backgrounds in scriptwriting</li>
            </ul>
            <h4 className="font-semibold mb-2 mt-4">Guest Lectures:</h4>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Renowned screenwriters and filmmakers</li>
              <li>Industry experts in screenplay writing and storytelling</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Software Training</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Final Draft (industry-standard scriptwriting software)</li>
              <li>Celtx (cloud-based scriptwriting and production tool)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certification & Career Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Script Writing upon course completion</li>
              <li>Career paths include screenwriting, script editing, story consulting, and playwrighting</li>
              <li>Industry guidance for networking and job placements</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Writers Guild of America (WGA)</li>
              <li>Screenwriters Association (SWA)</li>
              <li>International Screenwriters’ Association (ISA)</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Take the Next Step in Your Screenwriting Career</h3>
          <p className="mb-6 text-gray-700">
            Enroll in script writing classes at Sunrising Cinevision Academy and embark on a journey toward mastering scriptwriting. Whether you want to explore the fundamentals of script writing, master screenplay structure, or develop your storytelling abilities, this screenwriting course equips you with the skills and industry insights needed to succeed in film and television.
          </p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default ScriptwritingMain;
